/**
 * Slug normalization that matches the vaarmarkt-api `seo-pages` module
 * (src/entities/seo-pages/utils/normalize.ts). Keep the two in sync.
 *
 * This is deliberately NOT the same as `createBrandSlug` in util/brandSlug.js.
 * That one strips non-word characters outright and leaves diacritics alone,
 * which is what the existing /:slug brand page URLs are built from and must not
 * change. The API instead folds diacritics and turns punctuation into hyphens,
 * so the two disagree for a handful of brands:
 *
 *   J/BOATS               -> createBrandSlug: jboats     | api: j-boats
 *   REICHEL/PUGH          -> reichelpugh                 | reichel-pugh
 *   M.A.T.                -> mat                         | m-a-t
 *   AMARES (with grave)   -> amars                       | amares
 *   TIGE (with acute)     -> tig                         | tige
 *   BUTZFLETH (umlaut)    -> btzfleth                    | butzfleth
 *   W.A. SOUTER & SONS    -> wa-souter-sons              | w-a-souter-sons
 *   CHANTIER DE L'ESTEREL -> chantier-de-lesterel        | chantier-de-l-esterel
 *
 * Anything talking to the seo-pages API has to use this function, otherwise
 * those brands silently return no results.
 *
 * @param {string} input Brand/manufacturer string, canonical or display-cased
 * @returns {string} URL slug as stored by the API
 */
export const normalizeApiBrandSlug = input => {
  if (!input) return '';
  return input
    .toString()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');
};
